// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card .language-card {
    cursor: pointer;
    border: 1px solid #ddd;
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

.card .language-card:hover {
    background-color: #f0f0f0;
    border-color: #aaa;
}

.card .img-fluid {
    max-width: 50px;
    height: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/navbars/LanguageSelector.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,sBAAsB;IACtB,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".card .language-card {\n    cursor: pointer;\n    border: 1px solid #ddd;\n    transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.card .language-card:hover {\n    background-color: #f0f0f0;\n    border-color: #aaa;\n}\n\n.card .img-fluid {\n    max-width: 50px;\n    height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
